import React from 'react'

class MapTheme extends React.Component {
  constructor(props) {
    super(props);

    // styles for map
    this.state = {
      toner: {
        "version": 8,
        "sources": {
          "simple-tiles": {
            "type": "raster",
            "tiles": [
              "http://tile.stamen.com/toner/{z}/{x}/{y}.png"
            ],
            "tileSize": 256
          }
        },
        "layers": [{
          "id": "simple-tiles",
          "type": "raster",
          "source": "simple-tiles",
          "minzoom": 0,
          "maxzoom": 22
        }]
      },
      outdoors: "mapbox://styles/mapbox/outdoors-v11",
      dark: "mapbox://styles/mapbox/dark-v10",
      light: "mapbox://styles/mapbox/light-v10",
      satellite: "mapbox://styles/mille91/ck7fcndq92nzi1iodzt9b2mw2", // relies on token
      custom: "mapbox://styles/mille91/ck2q74ubr29tz1cqx9g6wuuvs",    // relies on token
    };

  }

  render() {

/*     <div className="map-theme" onClick={() => this.props.setMapTheme(this.state.toner)}>
      <img src="/map-theme-preview/toner.png" alt="Toner" />
      <h3>Toner</h3>
    </div>
    <div className="map-theme" onClick={() => this.props.setMapTheme(this.state.outdoors)}>
      <img src="/map-theme-preview/outdoor.png" alt="Outdoor" />
      <h3>Outdoor</h3>
    </div>
    <div className="map-theme" onClick={() => this.props.setMapTheme(this.state.satellite)}>
      <img src="/map-theme-preview/satellite.png" alt="Satellite" />
      <h3>Satellite</h3>
    </div>
    <div className="map-theme" onClick={() => this.props.setMapTheme(this.state.custom)}>
      <img src="/map-theme-preview/custom.png" alt="Custom" />
      <h3>Custom</h3>
    </div>*/

    return (
      <div>
        <div className="map-theme" onClick={() => this.props.setMapTheme(this.state.dark)}>
          <img src="/map-theme-preview/dark.png" alt="Dark" />
          <h3>Dark</h3>
        </div>
        <div className="map-theme" onClick={() => this.props.setMapTheme(this.state.light)}>
          <img src="/map-theme-preview/light.png" alt="Light" />
          <h3>Light</h3>
        </div>
       
      </div>
    );
  }
}

export default MapTheme


